export default function validateEducation(educationList) {
  const errors = [];
  const warnings = [];
  const list = educationList || [];
  
  if (list.length === 0) {
    errors.push("At least one education entry is required.");
  } else {
    list.forEach((edu, idx) => {
      const label = edu.college || edu.institution || `Entry #${idx + 1}`;
      const collegeVal = edu.college || edu.institution;
      if (!collegeVal || !collegeVal.trim()) {
        errors.push(`[${label}] College/University name is missing.`);
      }
      if (!edu.degree || !edu.degree.trim()) {
        errors.push(`[${label}] Degree/Program name is missing.`);
      }
      if (!edu.year || !edu.year.trim()) {
        warnings.push(`[${label}] Graduation year/duration missing.`);
      }
    });
  }

  let percentage = 0;
  if (list.length > 0) {
    let score = 0;
    list.forEach(edu => {
      const collegeVal = edu.college || edu.institution;
      if (collegeVal?.trim()) score += 34;
      if (edu.degree?.trim()) score += 33;
      if (edu.year?.trim()) score += 33;
    });
    percentage = Math.round(score / list.length);
  }

  return {
    id: "education",
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}
